import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../axios-Instance";
import { getLoginToken } from "../storage";
import { queryKeys } from "../react-query/constants";

async function getAllUsers() {
  const data = await axiosInstance({
    url: "/users",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const updateUser = async (formData: any) => {
  const data = await axiosInstance({
    url: `/thirdParty/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteUser = async (formData: any) => {
  const data = await axiosInstance({
    url: `/thirdParty/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

async function getUsersOnline() {
  const data = await axiosInstance({
    url: "/users/online-users",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  const apiData = data?.data?.data;
  const mappedData = apiData?.map((item: any) => ({
    ...item?.user,
    ...item?.session,
  }));
  return mappedData;
}

export function useUsers() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.users],
    queryFn: () => getAllUsers(),
  });
  return data;
}

export function useUsersOnline() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.online],
    queryFn: () => getUsersOnline(),
  });
  return data;
}

async function createThirdParty(formData: any) {
  const data = await axiosInstance({
    url: "/thirdParty",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return data?.data;
}

export function useCreateThirdParty() {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => createThirdParty(formData as any),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.users]);
    },
    onError: (error: any) => {},
  });
  return { mutate, isError, error, isSuccess, reset };
}

export function useUpdateUser() {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => updateUser(formData as any),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.users]);
    },
    onError: (error: any) => {},
  });
  return { mutate, isError, error, isSuccess, reset };
}

export function useDeleteUser() {
  const queryClient = useQueryClient();

  const { mutate, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (formData) => deleteUser(formData as any),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.users]);
    },
    onError: (error: any) => {},
  });
  return { mutate, isError, error, isSuccess, reset };
}
